import React from "react";
import { MENTOR } from "../../data";
import { ChevronDown, Instagram } from "lucide-react";

export default function Mentor() {
  return (
    <section className="sec">
      <div className="mx-auto max-w-[1080px] px-4 lg:max-w-[1440px] lg:px-12">
        <div className="numhead">
          <span className="numchip">{MENTOR.index}</span>
          <span className="numline" />
        </div>

        <div className="grid gap-10 md:grid-cols-5 items-start md:items-end lg:items-center mt-10">
          <div className="md:col-span-2">
            <div className="panel overflow-hidden" style={{ aspectRatio: "4/5", padding: 0 }}>
              {/* [FOTO_MENTOR] */}
              <img src="/img/claudio-mentor.webp" alt="Claudio, high ticket sales coach e fondatore di HighTicketSales.it" loading="lazy" className="w-full h-full object-cover" style={{ objectPosition: "center" }} />
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="kicker" style={{ color: "var(--blue-2)" }}>Ma chi ca**o è Claudio?</div>
            <ul className="mt-6" style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li className="py-2.5">
                <span style={{ fontSize: "clamp(1.7rem, 3.4vw, 2.4rem)", lineHeight: 1.2, display: "block", fontWeight: 400 }}>
                  <span style={{ display: "block" }}>Non importa <em style={{ fontStyle: "italic" }}>chi sono io</em>,</span>
                  <span style={{ display: "block", marginTop: "0.7em" }}>Ma chi ca**o puoi diventare tu con un prodotto come <span className="v-serif" style={{ fontStyle: "italic" }}>Sales Mastery</span>.</span>
                </span>
              </li>
            </ul>

            <a
              href="https://www.instagram.com/7figuresalesrep/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mentor-instagram-card"
              className="mt-8 block max-w-[560px] overflow-hidden rounded-2xl transition-transform duration-300 hover:-translate-y-1"
              style={{ border: "1px solid rgba(255,255,255,0.10)" }}
            >
              <img src="/img/instagram-profile.webp" alt="Profilo Instagram di Claudio: 7figuresalesrep" loading="lazy" className="block w-full h-auto" />
            </a>
            <a
              href="https://www.instagram.com/7figuresalesrep/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mentor-instagram-link"
              className="mt-4 inline-flex items-center gap-2 rounded-full px-4 py-1.5 transition-colors duration-200 hover:border-white/40 hover:text-white"
              style={{ border: "1px solid rgba(255,255,255,0.16)", color: "#98959F", fontSize: "0.82rem", fontWeight: 500, textDecoration: "none" }}
            >
              <Instagram size={14} /> Seguimi su Instagram
            </a>
          </div>
        </div>

        <div className="mt-12 flex justify-center">
          <button onClick={() => { const el = document.getElementById("prodotti"); if (el) el.scrollIntoView({ behavior: "smooth", block: "start" }); }} className="flex flex-col items-center gap-2" style={{ background: "none", border: "none", cursor: "pointer" }}>
            <span className="v-link" style={{ fontSize: "1.05rem" }}>{MENTOR.cta}</span>
            <ChevronDown className="v-bounce" size={28} style={{ color: "#4E85FF" }} />
          </button>
        </div>

      </div>
    </section>
  );
}
